import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location.interfaces";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";
import {
    CSRF_HEADER,
    ajax,
    getCSRFToken,
} from "tsi-common-react/src/utils/ajax";

import iconIconEmail from "../../img/retail-locator/icon-email.svg";
import { IEmailSendStorePostData } from "../models.interfaces";
import { buildStoreData } from "../utils";
import { LocatorSendResultsModal } from "./LocatorSendResults_Modal";
import { LocatorSurveyModal } from "./LocatorSurveyModal";

interface IProps {
    stores: IRetailStoreWithDistance[];
    getStoreNumber: (store: IRetailStoreWithDistance) => number;
}

interface IState {
    surveyOpen: boolean;
    surveyEmail: string;
}

// TODO(ssr, MEDIUM 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to async AJAX request handling, state management for survey modal, and integration with multiple child modals.
export class LocatorSendResultsEmail extends React.Component<IProps, IState> {
    state: IState = {
        surveyOpen: false,
        surveyEmail: "",
    };

    private readonly onSubmit = async (
        recipient: string,
        selectedStores: Set<ISyncStoreID>,
    ) => {
        const data: IEmailSendStorePostData = {
            email: recipient,
            stores: buildStoreData(this.props.stores, selectedStores),
        };
        await ajax
            .post("/api/email-retail-locator-results/")
            .set("Accept", "application/json")
            .set(CSRF_HEADER, await getCSRFToken())
            .send(data);
        this.setState({
            surveyOpen: true,
            surveyEmail: recipient,
        });
    };

    render() {
        return (
            <>
                <LocatorSendResultsModal
                    modalClassName="modal-email"
                    // TODO(i18n): Use t tagged template: buttonLabel={t`Email Results`}
                    buttonLabel="Email Results"
                    buttonImgSrc={iconIconEmail}
                    // TODO(i18n): Use t tagged template: buttonImgAlt={t`Email Results`}
                    buttonImgAlt="Email Results"
                    // TODO(i18n): Use t tagged template: modalTitle={t`Email Your Results`}
                    modalTitle="Email Your Results"
                    // TODO(i18n): Use jt to keep complete sentence together: modalDescription={jt`Check up to ${<strong>10</strong>} ${<span>results</span>} you would like emailed.`}
                    modalDescription={
                        <>
                            Check up to <strong>10</strong> <span>results</span>{" "}
                            you would like emailed.
                        </>
                    }
                    inputType="email"
                    // TODO(i18n): Use t tagged template: inputPlaceholder={t`Enter an Email Address`}
                    inputPlaceholder="Enter an Email Address"
                    // TODO(i18n): Use t tagged template: submitButtonLabel={t`Send`}
                    submitButtonLabel="Send"
                    maxSelected={10}
                    stores={this.props.stores}
                    getStoreNumber={this.props.getStoreNumber}
                    onSubmit={this.onSubmit}
                />
                <LocatorSurveyModal
                    isOpen={this.state.surveyOpen}
                    email={this.state.surveyEmail}
                    onClose={() => {
                        this.setState({
                            surveyOpen: false,
                        });
                    }}
                />
            </>
        );
    }
}
